import { render, staticRenderFns } from "./FAQAdd.vue?vue&type=template&id=404a6a2a"
import script from "./FAQAdd.vue?vue&type=script&lang=js"
export * from "./FAQAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports